<template>
  <div>
    <div
      class="ui-rounded-pill__wrapper"
      :style="{ 'background-color': theme.color }"
      style="
        font-weight: 500;
        border: none;
        height: 1rem;
        display: flex;
        flex-direction: row;
        text-align: left;
      "
    >
      <button
        @click="setThemeMatchSource(theme_index)"
        style="border: 0; color: white; display: flex; flex-direction: row"
        :style="{ 'background-color': theme.color }"
      >
        <SvgIconMeaningful
          style="cursor: pointer; display: flex; margin: 0; background-color: transparent"
          class="complete-icon-svg"
          icon="list"
          title="source of match"
        />
        <VisibleText style="margin-right: 1rem">{{ theme.theme_name }}</VisibleText>
        <span v-if="isDropped || isMLDropped">
          <SvgIconMeaningful
            style="cursor: pointer; display: flex; margin: 0; background-color: transparent"
            class="complete-icon-svg"
            icon="eye"
            title="has droppped logic"
        /></span>
      </button>

      <div
        v-if="themeMatchSource.includes(theme_index)"
        class="theme-reasons-card"
        :class="{ 'align-right': theme_index == theme_length - 1 }"
      >
        <!-- Header -->
        <div class="card-header">
          <div class="title">
            <VisibleText v-if="!isDropped && !isMLDropped">🎯 Reasons for theme match</VisibleText>
            <VisibleText v-else>🚫 Keyword matches ignored</VisibleText>
          </div>

          <button class="close-btn" @click="setThemeMatchSource(theme_index)">
            <SvgIconMeaningful icon="remove" title="close" />
          </button>
        </div>

        <!-- Content -->
        <div class="card-body">
          <!-- Manual note -->
          <div v-if="noteManualMatches(theme.theme_name)" class="reason-block">
            <div class="reason-label">📝 Theme added to entire text</div>
            <button
              class="action-btn"
              :disabled="propReadOnly"
              @click="dropNoteFromResponse(theme.theme_id)"
            >
              <SvgIconMeaningful icon="minus" title="remove manual match" />
            </button>
          </div>

          <!-- Sentence match -->
          <div v-if="noteMatches(theme.theme_name)" class="reason-block">
            <div class="reason-label">💬 Sentence match</div>
          </div>

          <!-- Keyword matches -->
          <div v-if="keywordMatches(theme.theme_name)" class="reason-block">
            <div v-if="!isDropped && !isMLDropped" class="reason-label">
              🔑 Keyword matches:
              <span class="reason-value">{{ keywordMatches(theme.theme_name) }}</span>
            </div>

            <button
              v-if="!isDropped && !isMLDropped"
              class="action-btn"
              :disabled="propReadOnly"
              @click="$emit('ignoreTheme', theme.theme_id)"
            >
              <SvgIconMeaningful icon="minus" title="ignore keywords" />
            </button>

            <!-- Reverse ignore (human) -->
            <div v-if="isDropped" class="reason-label">✖ Reverse theme ignore</div>
            <button
              v-if="isDropped"
              class="action-btn"
              :disabled="propReadOnly"
              @click="$emit('unignoreTheme', theme.theme_id)"
            >
              <SvgIconMeaningful icon="add" title="stop ignoring" />
            </button>

            <!-- Reverse ignore (ML) -->
            <div v-if="isMLDropped" class="reason-label">✖ Reverse ML ignore</div>
            <button
              v-if="isMLDropped"
              class="action-btn"
              :disabled="propReadOnly"
              @click="$emit('unignoreTheme', theme.theme_id)"
            >
              <SvgIconMeaningful icon="add" title="stop ignoring" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import SvgIconMeaningful from '@/components/UI/Svg/SvgIconMeaningful.vue';

export default {
  name: 'ResponseTheme',
  components: {
    SvgIconMeaningful,
  },
  props: {
    theme_index: {
      type: Number,
      default: () => -1,
    },
    theme: {
      type: Object,
      default: () => {},
    },
    theme_length: {
      type: Number,
      default: () => -1,
    },
    highlightedNotes: {
      type: Array,
      default: () => [],
    },
    highlightedKeywords: {
      type: Array,
      default: () => [],
    },
    otherMatches: {
      type: Array,
      default: () => [],
    },
    isDropped: {
      type: Boolean,
      default: () => false,
    },
    isMLDropped: {
      type: Boolean,
      default: () => false,
    },
    responseContent: {
      type: String,
      default: () => '',
    },
    propReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      themeMatchSource: [],
      themeIgnoredMatchSource: [],
    };
  },
  computed: {},
  async mounted() {},
  methods: {
    setThemeMatchSource(index) {
      let filteredThemes = [];
      filteredThemes = this.themeMatchSource.filter((theme) => theme == index);
      if (filteredThemes.length) {
        this.themeMatchSource = this.themeMatchSource.filter((theme) => theme != index);
      } else {
        this.themeMatchSource = [];
        this.themeMatchSource.push(index);
      }
      this.themeIgnoredMatchSource = [];
    },
    // The theme reason is from keyword matches
    keywordMatches(theme_name) {
      let found_themes = 0;
      if (this.highlightedKeywords) {
        for (let i = 0; i < this.highlightedKeywords.length; i++) {
          if (this.highlightedKeywords[i].theme_name == theme_name) {
            found_themes =
              found_themes +
              this.highlightedKeywords[i].matching_reasons.filter((reason) =>
                this.responseContent.toLowerCase().includes(reason.toLowerCase()),
              ).length;
          }
        }
      }
      return found_themes;
    },
    // The theme reason is from pressing the + and attaching a note theme to a whole response
    noteManualMatches(theme_name) {
      let found_themes = 0;
      if (this.highlightedNotes) {
        for (let i = 0; i < this.highlightedNotes.length; i++) {
          if (this.highlightedNotes[i].theme_name == theme_name) {
            found_themes =
              found_themes +
              this.highlightedNotes[i].matching_reasons.filter((reason) => reason == '').length;
          }
        }
      }
      return found_themes;
    },
    // The theme reason is from pressing adding a note directly to text within the response
    noteMatches(theme_name) {
      let found_themes = 0;
      if (this.highlightedNotes) {
        for (let i = 0; i < this.highlightedNotes.length; i++) {
          if (this.highlightedNotes[i].theme_name == theme_name) {
            found_themes =
              found_themes +
              this.highlightedNotes[i].matching_reasons.filter((reason) => reason !== '').length;
          }
        }
      }
      return found_themes;
    },
    toggleTheme(theme_id) {
      this.$emit('toggleTheme', theme_id);
    },
    dropNoteFromResponse(theme_id) {
      this.$emit('dropNoteFromResponse', theme_id);
      this.themeMatchSource = [];
      this.themeIgnoredMatchSource = [];
    },
    async dropFromKeywordMatch(theme_id) {
      this.$emit('ignoreTheme', theme_id);
      this.themeMatchSource = [];
      this.themeIgnoredMatchSource = [];
    },
  },
  watch: {},
};
</script>

<style scoped>
.theme-reasons-card {
  position: absolute;
  margin-top: 10rem;
  z-index: 10;
  background: white;
  border: 1px solid var(--outline-colour);
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  width: 22rem;
}

.theme-reasons-card.align-right {
  right: 3rem;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--outline-light-colour);
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--outline-light-colour);
  border-radius: 8px 8px 0 0;
}

.card-header .title {
  font-weight: 600;
  font-size: 1rem;
  color: var(--base-colour);
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
}

.card-body {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.reason-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reason-label {
  font-size: 0.95rem;
  color: var(--base-colour);
}

.reason-value {
  font-weight: 600;
  margin-left: 0.25rem;
}

.action-btn {
  border: 1px solid var(--outline-colour);
  background: var(--secondary-ui-colour);
  border-radius: 4px;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
